import ProjectCard from "../ProjectCard"; // Adjust the path as needed
import projects from "../data/projects";
import "aos/dist/aos.css";
import "../index.css";

export default function Projects() {
  return (
    <>
      <div className="sm:ml-20 ml-4">
        <h1
          className="text-2xl mb-10 mt-20"
          data-aos="zoom-in"
          data-aos-duration="2000"
          data-aos-easing="ease-in-out"
        >
          Projects
        </h1>
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            title={project.title}
            description={project.description}
            images={project.images}
            technologies={project.technologies}
            link={project.link}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
      <hr className="border-gray-600 my-20" />
    </>
  );
}
